import { defineSlotRecipe } from "@chakra-ui/react";

/**
 * Chakra v3 Tag Slot Recipe
 *
 * Slots: root, label, startElement, endElement, closeTrigger
 *
 * This recipe ensures that colorPalette tokens are used for styling,
 * allowing custom palettes like "primary" and "secondary" to work.
 */
const tagSlotRecipe = defineSlotRecipe({
  className: "tag",
  slots: ["root", "label", "startElement", "endElement", "closeTrigger"],
  base: {
    root: {
      display: "inline-flex",
      alignItems: "center",
      gap: "1",
      fontWeight: "medium",
      borderRadius: "sm",
      colorPalette: "gray",
    },
    label: {
      lineHeight: "1.2",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    closeTrigger: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      borderRadius: "xs",
      transition: "background 0.2s",
      _hover: {
        opacity: 0.8,
      },
    },
    startElement: {
      display: "flex",
      alignItems: "center",
    },
    endElement: {
      display: "flex",
      alignItems: "center",
    },
  },
  variants: {
    size: {
      sm: {
        root: {
          px: "2",
          py: "0.5",
          textStyle: "xs",
          gap: "1",
        },
        closeTrigger: {
          fontSize: "sm",
        },
      },
      md: {
        root: {
          px: "2.5",
          py: "1",
          textStyle: "sm",
          gap: "1.5",
        },
        closeTrigger: {
          fontSize: "md",
        },
      },
      lg: {
        root: {
          px: "3",
          py: "1.5",
          textStyle: "md",
          gap: "2",
        },
        closeTrigger: {
          fontSize: "lg",
        },
      },
      xl: {
        root: {
          px: "3.5",
          py: "2",
          textStyle: "md",
          gap: "2",
        },
        closeTrigger: {
          fontSize: "xl",
        },
      },
    },
    variant: {
      subtle: {
        root: {
          bg: "colorPalette.subtle",
          color: "colorPalette.fg",
        },
      },
      solid: {
        root: {
          bg: "colorPalette.solid",
          color: "colorPalette.contrast",
        },
      },
      outline: {
        root: {
          borderWidth: "1px",
          borderColor: "colorPalette.solid",
          color: "colorPalette.fg",
        },
      },
      surface: {
        root: {
          bg: "colorPalette.subtle",
          color: "colorPalette.fg",
          borderWidth: "1px",
          borderColor: "colorPalette.300",
        },
      },
    },
  },
  defaultVariants: {
    size: "sm",
    variant: "surface",
  },
});

export default tagSlotRecipe;
